import Image from 'next/image';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Section from '../Section';
const BookTopHero = ({ page, title, subheading }) => {
  return (
    <div className='top-hero-container'>
      <div className='top-hero-image-container'>
      </div>
      <Section className='top-hero-content-container'>
        <Row className='justify-content-center'>
          <Col xs={12} lg={10} xl={9}>
            <h1>{title}</h1> <p>{subheading}</p>
            <div className='steps-container'>
              <div
                className='step-container'
                style={{ opacity: page === 'book' ? 1 : 0.5 }}
              >
                <h6>CONTACT INFORMATION</h6>
                <div className='step-circle'>
                  <span className='circle-number'>1</span>
                </div>
              </div>
              <hr />
              <div
                className='step-container'
                style={{ opacity: page === 'schedule' ? 1 : 0.4 }}
              >
                <h6>SCHEDULE CLEANING</h6>
                <div className='step-circle'>
                  <span className='circle-number'>2</span>
                </div>
              </div>
              <hr />
              <div
                className='step-container'
                style={{ opacity: page === 'confirm' ? 1 : 0.4 }}
              >
                <h6>REVIEW & PURCHASE</h6>
                <div className='step-circle'>
                  <span className='circle-number'>3</span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Section>
    </div>
  );
};

export default BookTopHero;
